import React, { useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { api_base_url } from "config";

const ImportCouponsButton = ({ onImportComplete }) => {
  const [isImporting, setIsImporting] = useState(false);

  const getAuthHeaders = () => {
    const headers = {
      'Content-Type': 'application/json',
    };

    const bearerToken = localStorage.getItem('authToken') || 
                       localStorage.getItem('access_token') ||
                       sessionStorage.getItem('authToken');
    
    if (bearerToken) {
      headers['Authorization'] = `Bearer ${bearerToken}`;
      return headers;
    }

    const drfToken = localStorage.getItem('token') || 
                     localStorage.getItem('auth_token');
    
    if (drfToken) {
      headers['Authorization'] = `Token ${drfToken}`;
      return headers;
    }

    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]')?.value ||
                      document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    
    if (csrfToken) {
      headers['X-CSRFToken'] = csrfToken;
    }

    return headers;
  };

  const handleImportCoupons = async () => {
    setIsImporting(true);
    try {
      const response = await fetch(`${api_base_url}/api/import-crawled-coupons/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        credentials: 'include', // Sempre inclui cookies de sessão
      });

      if (response.status === 401) {
        console.log('Tentativa com autenticação falhou, tentando sem autenticação...');
        
        const fallbackResponse = await fetch(`${api_base_url}/api/import-crawled-coupons/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });

        if (!fallbackResponse.ok) {
          throw new Error(`Erro de autenticação: ${fallbackResponse.status}. Verifique se você está logado.`);
        }
        
        const data = await fallbackResponse.json();
        alert(`Importação concluída! ${data.message}`);
        if (onImportComplete) onImportComplete(data);
        return;
      }

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      alert(`Importação concluída! ${data.message}`);
      
      if (onImportComplete) {
        onImportComplete(data);
      }
      
    } catch (error) {
      console.error('Erro ao importar cupons:', error);
      
      // Mensagens de erro mais específicas
      if (error.message.includes('401')) {
        alert('Erro de autenticação. Verifique se você está logado no sistema.');
      } else if (error.message.includes('403')) {
        alert('Você não tem permissão para executar esta ação.');
      } else if (error.message.includes('500')) {
        alert('Erro interno do servidor. Verifique os logs do backend.');
      } else {
        alert(`Erro ao importar cupons: ${error.message}`);
      }
    } finally {
      setIsImporting(false);
    }
  };

  return (
    <button 
      className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-green-600 text-white hover:bg-green-700 h-9 px-4 py-2"
      onClick={handleImportCoupons}
      disabled={isImporting}
      title="Executa o comando import_crawled_coupons do Django"
    >
      {isImporting ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Importando...
        </>
      ) : (
        <>
          <Upload className="mr-2 h-4 w-4" />
          Importar Cupons
        </>
      )}
    </button>
  );
};

export default ImportCouponsButton;